import { FaArrowRight } from "react-icons/fa/";
import { FaCalendar } from "react-icons/fa/";
import { FaTag } from "react-icons/fa/";
import { FaUser } from "react-icons/fa/";
import Img from "gatsby-image";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

const Item = props => {
  const {
    theme,
    post: {
      excerpt,
      fields: { slug, prefix },
      frontmatter: { title, category, author, draft }
    }
  } = props;

  var category2 = "";

  if (category == null) {
    category2 = "未分類";
  } else if (category == "関東春ロボコン") {
    category2 = "春ロボ";
  } else {
    category2 = category;
  }

  return (
    <React.Fragment>
      <hr />
      <Link to={slug} key={slug} className="link">
        <div className="row latest">
          <div className="col-3 order-2 order-sm-1 col-sm-auto offset-sm-1 tag d-flex align-items-center justify-content-center ">
            <span
              className={
                category2.toUpperCase().charAt(0) == "R"
                  ? "R"
                  : category2.toUpperCase().charAt(0) == "F"
                  ? "F"
                  : category2.toUpperCase().charAt(0) == "春"
                  ? "K"
                  : "N"
              }
            >
              {category2.toUpperCase().replace(/-/g, "")}
            </span>
          </div>
          <div className="col-6 offset-1 order-3 offset-sm-0 order-sm-2 col-sm-auto date d-flex align-items-center">
            {prefix.replace(/-/g, ".")}
          </div>
          <div className="col-12 order-1 order-sm-3 col-sm title d-flex align-items-center">
            {title}
          </div>
        </div>
      </Link>

      {/* --- STYLES --- */}
      <style jsx>{`
        hr {
          width: 100%;
          margin: auto;
        }
        .latest {
          line-height: 1.6;
          color: black;
          height: 80px;
          margin: 5px;
          font-size: 17px;
        }
        .tag {
          width: 100px;
          padding: 0px;
          text-align: center;
          margin: 0px;
          margin-right: 10px;
          margin-left: 20px;
          color: white;
        }
        .date {
          width: 100px;
          padding: 0px;
          margin-left: 20px;
        }
        .title {
          word-break: break-all;
          text-align: justify;
        }

        .R,
        .F,
        .K,
        .N {
          width: 100%;
          text-align: center;
          border-radius: 5px;
          padding: 5px;
        }

        .R {
          background-color: #009fc5;
        }
        .F {
          background-color: #7bd388;
        }
        .K {
          background-color: #df3237;
        }
        .N {
          background-color: #a58b35;
        }

        @media (max-width: 768px) {
          .latest {
            height: 120px;
          }
        }

        @media (max-width: 575px) {
          .latest {
            height: 120px;
            margin: 5px;
            font-size: 20px;
          }
          .tag {
            width: 80px;
            padding: 0px;
            text-align: center;
            margin: 0px;
            margin-right: 10px;
            margin-left: 20px;
          }
          .date {
            width: 70px;
            padding: 0px;
          }
          .R,
          .F,
          .K,
          .N {
            font-size: 20px;
          }
        }

        @media (max-width: 450px) {
          .latest {
            height: 130px;
            font-size: 18px;
          }
          .R,
          .F,
          .K,
          .N {
            font-size: 16px;
            margin-left: 10px;
          }
        }
        @media (max-width: 380px) {
          .latest {
            height: 150px;
            font-size: 18px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

Item.propTypes = {
  post: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default Item;
